import { render, staticRenderFns } from "./AccountantsDashboardMenu.vue?vue&type=template&id=52efcd30&scoped=true&"
import script from "./AccountantsDashboardMenu.vue?vue&type=script&lang=js&"
export * from "./AccountantsDashboardMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52efcd30",
  null
  
)

export default component.exports